import { getSelectedOptionsKey } from "./productOptions";

/**
 * Merge guest cart (localStorage) with user cart (API)
 * Returns merged cart items
 */
export const mergeGuestCartWithUserCart = (guestCart, userCart) => {
  const merged = [...userCart];

  guestCart.forEach((guestItem) => {
    const existingIndex = merged.findIndex((item) => item.product_id === guestItem.product_id && getSelectedOptionsKey(item.selected_options) === getSelectedOptionsKey(guestItem.selected_options));

    if (existingIndex >= 0) {
      // Product exists in both carts - sum quantities
      merged[existingIndex].quantity += guestItem.quantity;
    } else {
      // Product only in guest cart - add it
      merged.push(guestItem);
    }
  });

  return merged;
};

/**
 * Get cart from localStorage
 */
export const getGuestCart = () => {
  try {
    const cart = localStorage.getItem("guestCart");
    if (!cart) return [];

    const { items, expiresAt } = JSON.parse(cart);

    // Check if cart has expired (7 days)
    if (new Date(expiresAt) < new Date()) {
      localStorage.removeItem("guestCart");
      return [];
    }

    return items;
  } catch (error) {
    console.error("Error reading guest cart:", error);
    return [];
  }
};

/**
 * Save cart to localStorage with 7-day expiration
 */
export const saveGuestCart = (items) => {
  try {
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 7); // 7 days from now

    localStorage.setItem(
      "guestCart",
      JSON.stringify({
        items,
        expiresAt: expiresAt.toISOString(),
      }),
    );
  } catch (error) {
    console.error("Error saving guest cart:", error);
  }
};

/**
 * Clear guest cart from localStorage
 */
export const clearGuestCart = () => {
  localStorage.removeItem("guestCart");
};
